import { useMemo } from "react";
import { useQuery } from "@apollo/client/react";
import { FormNamesDocument } from "#app/lib/data";
import { UNTITLED_FORM } from "#app/lib/forms";
import type { EntityItemConfig, EntityPoolConfig } from "@salestrak/ui";

const POOL_ID = "forms";

const STATUS_DESCRIPTION: Record<string, string | undefined> = {
  closed: "Closed",
  draft: "Not published",
};

export function useFormPool({ skip = false }: { skip?: boolean } = {}) {
  const { data, loading } = useQuery(FormNamesDocument, { skip });

  const items = useMemo<EntityItemConfig[]>(
    () =>
      (data?.forms ?? []).map((form) => ({
        id: form.id,
        title: form.name || UNTITLED_FORM,
        avatar: { icon: "clipboard-check", padded: true },
        description: STATUS_DESCRIPTION[form.status],
      })),
    [data],
  );

  const pool = useMemo<EntityPoolConfig>(
    () => ({
      id: POOL_ID,
      label: "Forms",
      items,
    }),
    [items],
  );

  return { pool, loading };
}

export { POOL_ID as FORM_POOL_ID };
